import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./SidebarItem.css.js";
// A sidebar navigation row: an icon (or a colored trip dot), a label, an optional trailing
// count, and an amber-tinted active state.
export const SidebarItem = ({ children, icon, dotColor, active = false, badge, onClick }) => {
    const clickable = onClick !== undefined;
    const onKeyDown = (e) => {
        if (clickable && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            onClick?.();
        }
    };
    return (_jsxs("div", { className: styles.row, "data-active": active, role: clickable ? "button" : undefined, tabIndex: clickable ? 0 : undefined, "aria-current": active ? "page" : undefined, onClick: onClick, onKeyDown: onKeyDown, children: [dotColor !== undefined && _jsx("span", { className: styles.dot, style: { backgroundColor: dotColor }, "aria-hidden": true }), icon, _jsx("span", { className: styles.label, children: children }), badge !== undefined && badge !== null && (_jsx("span", { className: styles.badge, "data-active": active, children: badge }))] }));
};
//# sourceMappingURL=SidebarItem.js.map